// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".phone-list-bg[data-v-14192dd1]{background:linear-gradient(59deg,#f40,#ff8100,#ffc238)}.phone-list-bg[data-v-14192dd1] h2{font-size:2.3rem}@media screen and (min-width:640px){.phone-list-bg[data-v-14192dd1] h2{font-size:5rem}}.tag-items[data-v-14192dd1] .v-btn{letter-spacing:normal!important}", ""]);
// Exports
module.exports = exports;
